import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { IMAGES } from "../../lib/site";

const LINKS = [
  { label: "Story", href: "#story" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Areas", href: "#areas" },
  { label: "Reviews", href: "#reviews" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-warm-white/80 border-b border-border-stone/60" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={IMAGES.logo} alt="Casa Galênê" className="h-16 w-16 object-contain" />
          <span className="block leading-tight">
            <span className="block font-serif text-base sm:text-lg text-ocean-teal">Casa Galênê</span>
            <span className="block text-[9px] sm:text-[10px] tracking-[0.3em] uppercase text-antique-gold">Cleaning</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="link-underline text-sm font-sans tracking-wide text-charcoal/80 hover:text-ocean-teal transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="nav-quote-btn"
            className="rounded-full bg-ocean-teal px-6 py-2.5 text-sm font-medium text-warm-white hover:bg-ocean-teal/90 transition-colors"
          >
            Request a Quote
          </a>
        </nav>

        <button
          className="md:hidden text-ocean-teal"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="md:hidden bg-warm-white border-t border-border-stone px-6 py-6 flex flex-col gap-5"
          data-testid="nav-mobile-menu"
        >
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-ocean-teal font-sans">
              {l.label}
            </a>
          ))}
          <a href="#quote" onClick={() => setOpen(false)} className="rounded-full bg-ocean-teal px-6 py-3 text-center text-warm-white">
            Request a Quote
          </a>
        </motion.div>
      )}
    </motion.header>
  );
}
